import React, { useState } from 'react';
import { EuiGlobalToastList, EuiLink, EuiCode } from '@elastic/eui';

let addToastHandler;
let toastSequence = 0;
const recentToastTimes = new Map();
const toastDedupeWindowMs = 5000;

export function addToast(message, type, dedupeKey) {
    const now = Date.now();
    if (dedupeKey) {
        const lastShownAt = recentToastTimes.get(dedupeKey) || 0;
        if (now - lastShownAt < toastDedupeWindowMs) {
            return;
        }
        recentToastTimes.set(dedupeKey, now);
    }
    let color = 'success';

    if (type === 'error') {
        color = 'danger';
    }

    const data = {
        color: color,
        id: `${ now }-${ toastSequence++ }`,
        text: message,
        toastLifeTimeMs: 6000
    };
    addToastHandler(data);
}

const Toast = () => {
    const [toasts, setToasts] = useState([]);

    addToastHandler = data => setToasts(currentToasts => currentToasts.concat(data));
    const dismissToast = toast => {
        setToasts(currentToasts => currentToasts.filter(item => item.id !== toast.id));
    };
    return (
        <EuiGlobalToastList
            toasts={ toasts }
            dismissToast={ dismissToast }
            toastLifeTimeMs={ 6000 }
        />
    );
};

export default Toast;
